import React, {memo} from "react";
import styles from './FJKeywordInfoView.module.less';
import FJLocalStore from "../../../../store/FJLocalStore";
import classNames from 'classnames';
import FJKeyword from "../../../../common/component/FJKeyword";

function FJKeywordInfoView(props) {
	const {active, keywordClick, hotWords} = props;
	return (
		<div className={classNames(styles.keyword_info, {[styles.active]: active})}>
			<span className={styles.keyword_text}>{FJLocalStore._('keywords')}:</span>
			<div className={styles.list}>
				{
					hotWords.map(item => {
							return <FJKeyword text={item}
							                  key={item}
							                  onClick={(item) => {
								                  keywordClick(item)
							                  }}
							/>
						}
					)
				}
			</div>
		</div>
	)
}


export default memo(FJKeywordInfoView);